import AnalyticsSummary from "../components/Dashboard/AnalyticsSummary";
import ParticipantHistoryReport from "../components/Dashboard/ParticipantHistoryReport";

const Analytics = () => (
  <div className="min-h-screen bg-gray-100 px-3 py-6 sm:px-4">
    <div className="mx-auto max-w-7xl space-y-5">
      <div className="rounded-xl bg-white p-5 shadow-lg sm:p-6">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#004a7e]">
          Admin analytics
        </p>
        <h1 className="mt-2 text-2xl font-black text-gray-900 sm:text-3xl">
          Analytics
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Track event activity, ride coordination, active drivers, active
          participants, and frequent driver-participant pairs.
        </p>
      </div>

      <AnalyticsSummary />
      <ParticipantHistoryReport />
    </div>
  </div>
);

export default Analytics;
